(function () {
  'use strict';
  function money(cents) { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100); }
  function grundpreisHtml(item, className) {
    var m = item.unit_price_measurement;
    if (!item.unit_price || !m || !m.reference_unit) return '';
    var ref = (m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : '') + m.reference_unit;
    return '<small class="grundpreis ' + className + '">' + money(item.unit_price) + ' / ' + ref + '</small>';
  }
  function originalTotal(cart) { return cart.original_total_price == null ? cart.total_price : cart.original_total_price; }
  function notify(cart) { document.dispatchEvent(new CustomEvent('1a:cart:updated', { detail: cart })); }
  function updateBadge(cart) {
    try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() })); } catch (error) {}
    document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (element) { element.textContent = cart.item_count > 0 ? String(cart.item_count) : ''; });
    ['cart:update', 'cart-update', 'theme:cart-update'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { data: { itemCount: cart.item_count } }, bubbles: true }));
    });
  }
  function CartPage(root) { this.root = root; this.busy = false; this.bind(); this.loadRecommendations(); }
  CartPage.prototype.bind = function () {
    var self = this;
    var discountForm = this.root.querySelector('[data-discount-form]');
    if (discountForm) discountForm.addEventListener('submit', function (event) {
      event.preventDefault(); self.applyDiscount(discountForm.elements.discount.value);
    });
    this.root.addEventListener('click', function (event) {
      if (event.target.closest('[data-discount-remove]')) { self.removeDiscount(); return; }
      var suggestion = event.target.closest('[data-discount-suggestion-button]');
      if (suggestion) { self.applyDiscount(suggestion.dataset.code); return; }
      var quantityButton = event.target.closest('[data-cart-item] [data-quantity]');
      if (quantityButton) {
        var item = quantityButton.closest('[data-cart-item]');
        self.change(item.dataset.key, Number(quantityButton.dataset.quantity), item);
        return;
      }
      var addButton = event.target.closest('[data-add-variant]');
      if (addButton) self.add(Number(addButton.dataset.addVariant), addButton);
    });
  };
  CartPage.prototype.change = function (key, quantity, item) {
    if (this.busy) return;
    this.busy = true; item.setAttribute('aria-busy', 'true');
    var self = this;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) })
      .then(function (response) { if (!response.ok) throw new Error('Cart change failed'); return response.json(); })
      .then(function (cart) {
        if (self.render(cart)) return;
        notify(cart); updateBadge(cart);
      })
      .catch(function () { item.removeAttribute('aria-busy'); self.busy = false; });
  };
  CartPage.prototype.add = function (variantId, button) {
    if (this.busy || !variantId) return;
    this.busy = true; button.setAttribute('aria-busy', 'true');
    var self = this;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (response) { if (!response.ok) throw new Error('Cart add failed'); return fetch('/cart.js'); })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (self.render(cart)) return;
        notify(cart); updateBadge(cart);
      })
      .catch(function () { button.removeAttribute('aria-busy'); self.busy = false; });
  };
  CartPage.prototype.render = function (cart) {
    var renderedKeys = Array.from(this.root.querySelectorAll('[data-cart-item]')).map(function (element) { return element.dataset.key; });
    var needsStructureRefresh = !cart.item_count || cart.items.some(function (item) { return renderedKeys.indexOf(item.key) === -1; });
    if (needsStructureRefresh) { this.refreshSection(cart); return true; }
    var itemsByKey = {};
    cart.items.forEach(function (item) { itemsByKey[item.key] = item; });
    this.root.querySelectorAll('[data-cart-item]').forEach(function (element) {
      var item = itemsByKey[element.dataset.key];
      if (!item) { element.remove(); return; }
      element.removeAttribute('aria-busy');
      var buttons = element.querySelectorAll('[data-quantity]');
      element.querySelector('.wc1a-quantity span').textContent = item.quantity;
      buttons[0].dataset.quantity = item.quantity - 1; buttons[1].dataset.quantity = item.quantity + 1;
      element.querySelector('.wc1a-item__prices').innerHTML = '<strong>' + money(item.final_line_price) + '</strong>' + (item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '') + grundpreisHtml(item, 'wc1a-item__grundpreis');
    });
    var before = originalTotal(cart); var savings = Math.max(0, before - cart.total_price);
    this.root.querySelector('[data-cart-count-label]').textContent = cart.item_count + ' Artikel';
    this.root.querySelector('[data-summary-original]').textContent = money(before);
    this.root.querySelector('[data-summary-total]').textContent = money(cart.total_price);
    this.root.querySelector('[data-summary-discount]').textContent = '−' + money(savings);
    this.renderDiscount(cart); this.renderTier(cart); this.filterRecommendations(cart); this.busy = false;
    return false;
  };
  CartPage.prototype.showDiscountError = function (message) {
    var error = this.root.querySelector('[data-discount-error]');
    if (!error) return;
    error.textContent = message || ''; error.hidden = !message;
  };
  CartPage.prototype.renderDiscount = function (cart) {
    if (!window.BundleStaffel) return;
    this.cart = cart;
    var code = window.BundleStaffel.activeCode(cart);
    var savings = Math.max(0, originalTotal(cart) - cart.total_price);
    var form = this.root.querySelector('[data-discount-form]');
    var applied = this.root.querySelector('[data-discount-applied]');
    var summary = this.root.querySelector('.wc1a-summary__discount');
    var suggestion = this.root.querySelector('[data-discount-suggestion]');
    if (!form || !applied || !summary || !suggestion) return;
    applied.hidden = !code;
    summary.hidden = !(code && savings > 0); suggestion.hidden = true;
    if (code) {
      applied.querySelector('[data-discount-name]').textContent = code;
      applied.querySelector('[data-discount-amount]').textContent = '−' + money(savings);
      summary.querySelector('[data-summary-code]').textContent = code;
    } else if (cart.item_count >= 2) {
      var result = window.BundleStaffel.calculate(cart.item_count, originalTotal(cart));
      var suggestedCode = window.BundleStaffel.codeForTier(result.current);
      suggestion.querySelector('[data-discount-suggestion-text]').textContent = 'Du hast ' + cart.item_count + ' Produkte im Warenkorb. Mit dem Code ' + suggestedCode + ' sparst du ' + result.currentPercent + ' %.';
      suggestion.querySelector('[data-discount-suggestion-button]').dataset.code = suggestedCode;
      suggestion.hidden = false;
    }
  };
  CartPage.prototype.applyDiscount = function (value) {
    var code = String(value || '').trim().toUpperCase();
    if (!code || !window.BundleStaffel) return;
    var self = this; var form = this.root.querySelector('[data-discount-form]'); var button = form.querySelector('button[type="submit"]');
    this.showDiscountError('');
    var active = window.BundleStaffel.activeCode(this.cart);
    if (active && active.toUpperCase() !== code) {
      this.showDiscountError('Es kann immer nur ein Code gelten. Entferne den aktiven Code, um diesen zu nutzen.'); return;
    }
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    window.BundleStaffel.setDiscounts([code]).then(function (cart) {
      if (!cart) return;
      var applicable = Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (discount) { return discount && typeof discount.code === 'string' && discount.code.toUpperCase() === code && discount.applicable === true; });
      if (applicable) { form.elements.discount.value = ''; self.render(cart); notify(cart); updateBadge(cart); return; }
      return window.BundleStaffel.setDiscounts([]).then(function (cleanCart) {
        self.render(cleanCart); notify(cleanCart); updateBadge(cleanCart);
        self.showDiscountError('Der Code konnte nicht eingelöst werden.');
      });
    }).catch(function () { self.showDiscountError('Der Code konnte nicht eingelöst werden.'); }).then(function () {
      button.disabled = false; button.removeAttribute('aria-busy');
    });
  };
  CartPage.prototype.removeDiscount = function () {
    if (!window.BundleStaffel) return;
    var self = this; this.showDiscountError('');
    window.BundleStaffel.setDiscounts([]).then(function (cart) { self.render(cart); notify(cart); updateBadge(cart); }).catch(function () {});
  };
  CartPage.prototype.refreshSection = function (cart) {
    var self = this;
    fetch('/cart?section_id=' + encodeURIComponent(this.root.dataset.sectionId))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wc1a]');
        if (!incoming) throw new Error('Cart section missing');
        self.root.replaceWith(incoming);
        var page = new CartPage(incoming);
        if (cart.item_count) page.render(cart);
        notify(cart); updateBadge(cart);
      })
      .catch(function () { self.busy = false; });
  };
  CartPage.prototype.renderTier = function (cart) {
    if (!window.BundleStaffel) return;
    var result = window.BundleStaffel.calculate(cart.item_count, originalTotal(cart));
    var primary = this.root.querySelector('[data-tier-primary]'); var secondary = this.root.querySelector('[data-tier-secondary]');
    if (!primary || !secondary) return;
    if (result.next) {
      primary.textContent = 'Noch ' + result.remaining + ' Produkt für ' + result.next.percent + ' % auf alles';
      secondary.textContent = money(result.additionalSavingsCents) + ' mehr Ersparnis mit dem Code ' + window.BundleStaffel.codeForTier(result.next); secondary.hidden = false;
    } else { primary.textContent = 'Höchste Stufe erreicht'; secondary.textContent = ''; secondary.hidden = true; }
    this.root.querySelectorAll('[data-tier-minimum]').forEach(function (segment) { segment.classList.toggle('is-reached', result.quantity >= Number(segment.dataset.tierMinimum)); });
  };
  CartPage.prototype.filterRecommendations = function (cart) {
    var ids = cart.items.map(function (item) { return String(item.product_id); });
    this.root.querySelectorAll('.wc1a-recommendation').forEach(function (card) { card.hidden = ids.indexOf(card.dataset.productId) !== -1; });
  };
  CartPage.prototype.loadRecommendations = function () {
    var container = this.root.querySelector('[data-recommendations-container]'); var productId = this.root.dataset.firstProductId;
    if (!container || !productId || container.dataset.recommendationsResponse === 'true') return;
    fetch('/recommendations/products?product_id=' + encodeURIComponent(productId) + '&limit=12&intent=complementary&section_id=' + encodeURIComponent(this.root.dataset.sectionId))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations-list]');
        var current = container.querySelector('[data-recommendations-list]');
        if (incoming && current && incoming.children.length) current.innerHTML = incoming.innerHTML;
      }).catch(function () {});
  };
  function init() {
    document.querySelectorAll('[data-wc1a]').forEach(function (root) {
      var page = new CartPage(root);
      fetch('/cart.js').then(function (response) { return response.json(); }).then(function (cart) { if (cart.item_count) page.render(cart); else page.renderDiscount(cart); }).catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
